import actions from './utils/actions';
import { loginOutContor } from './utils/index';
const microApps = [
	{
		name: 'registered-audit-manager',
		entry: `${process.env.REACT_APP_REGISTEREDAUDIT_URL}/registered-audit-manager/`,
		prefixPath: '/zeus-system/registered-audit-manager',
		container: '#registered-audit-manager'
	},
	{
		name: 'employeeEntryAndResignation',
		entry: `${process.env.REACT_APP_EMPLOYEE}/employeeEntryAndResignation/`,
		prefixPath: '/zeus-system/employeeEntryAndResignation',
		container: '#employeeEntryAndResignation'
	},
	{
		name: 'system-permissions',
		entry: `${process.env.REACT_APP_SYSTEM_URL}/system-permissions/`,
		prefixPath: '/zeus-system/system-permissions',
		container: '#system-permissions'
	},
	{
		name: 'bpo',
		entry: `${process.env.REACT_APP_BPO_URL}/bpo/`,
		prefixPath: '/zeus-system/bpo',
		container: '#bpo'
	},
	{
		name: 'Outsourcing',
		entry: `${process.env.REACT_APP_OUTSOURCING_URL}/Outsourcing/`,
		prefixPath: '/zeus-system/Outsourcing',
		container: '#Outsourcing'
	},
	{
		name: 'recruitment-more',
		entry: `${process.env.REACT_APP_RECRUITMENT_URL}/recruitment-more/`,
		prefixPath: '/zeus-system/recruitment-more',
		container: '#recruitment-more'
	},
	{
		name: 'statements',
		entry: `${process.env.REACT_APP_STATEMENTS_URL}/statements/`,
		prefixPath: '/zeus-system/statements',
		container: '#statements'
	},
	{
		name: 'invoice-manages',
		entry: `${process.env.REACT_APP_INVOICE_URL}/invoice-manages/`,
		prefixPath: '/zeus-system/invoice-manages',
		container: '#invoice-manages'
	},
	{
		name: 'commercial-insurance',
		entry: `${process.env.REACT_APP_RECRUITMENT_URL}/commercial-insurance/`,
		prefixPath: '/zeus-system/commercial-insurance',
		container: '#commercial-insurance'
	},
	{
		name: 'government-supervision',
		entry: `${process.env.REACT_APP_RECRUITMENT_URL}/government-supervision/`,
		prefixPath: '/zeus-system/government-supervision',
		container: '#government-supervision'
	},
	{
		name: 'bank-manager-pc',
		entry: `${process.env.REACT_APP_BANK_URL}/bank-manager-pc/`,
		prefixPath: '/zeus-system/bank-manager-pc',
		container: '#bank-manager-pc'
	},
	{
		name: 'fine-report',
		entry: `${process.env.REACT_APP_FINEREPORT_URL}/fine-report/`,
		prefixPath: '/zeus-system/fine-report',
		container: '#fine-report'
	},
	{
		name: 'financemanage',
		entry: `${process.env.REACT_APP_FINANCEMANAGE_URL}/financemanage/`,
		prefixPath: '/zeus-system/financemanage',
		container: '#financemanage'
	}
];
const apps = microApps.map((item) => {
	return {
		...item,
		props: {
			routerBase: item.prefixPath, // 下发基础路由
			getGlobalState: actions.getGlobalState, // 下发getGlobalState方法
			zeusRouter: actions.zeusRouter,
			loginOut: loginOutContor
		}
	};
});
export default apps;
